import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import VueApexCharts from 'vue3-apexcharts'
import ApexCharts from 'apexcharts'
import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n'
import './styles/index.css'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VueApexCharts)

app.config.globalProperties.$apexcharts = ApexCharts

// Monta só depois da navegação inicial resolver. Sem isso o onMounted do App.vue
// roda com a rota vazia (START_LOCATION), requiresAuth fica undefined e o guard de
// rota pública não corta — disparando GET /manager/accounts autenticado, que em
// rota pública sem sessão volta 401 e redireciona ao login.
router.isReady().then(() => app.mount('#app'))

declare module 'vue' {
  interface ComponentCustomProperties {
    $apexcharts: typeof ApexCharts
  }
}
